/* */ 
var toIObject = require('./$.to-iobject'),
    getNames = require('./$').getNames,
    toString = {}.toString;
var windowNames = typeof window == 'object' && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function(it) {
  try {
    return getNames(it);
  } catch (e) {
    return windowNames.slice();
  }
};
module.exports.get = function getOwnPropertyNames(it) {
  if (windowNames && toString.call(it) == '[object Window]')
    return getWindowNames(it);
  return getNames(toIObject(it));
};
